var _title, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAvatar = function SvgAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "21px",
    viewBox: "0 0 18 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Placeholder")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.172549 0 0 0 0 0.172549 0 0 0 0 0.180392 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-components",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Building-blocks",
    transform: "translate(-339.000000, -2579.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Regular-photos",
    transform: "translate(88.000000, 2570.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Placeholder",
    transform: "translate(240.000000, 0.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,18.6666667 L0,18.6666667 C0,15.7213334 2.38800001,13.3333334 5.33333336,13.3333334 L10.6666667,13.3333334 C13.6120001,13.3333334 16,15.7213334 16,18.6666667 L16,18.6666667",
    id: "Path",
    stroke: "#D1D1D6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2065334,1.32817334 C12.9774267,3.09906668 12.9774267,5.97026669 11.2065334,7.74116003 C9.43564004,9.51205337 6.56444003,9.51205337 4.79354669,7.74116003 C3.02265335,5.97026669 3.02265335,3.09906668 4.79354669,1.32817334 C6.56444003,-0.442720002 9.43564004,-0.442720002 11.2065334,1.32817334",
    id: "Path",
    stroke: "#D1D1D6",
    strokeWidth: 2
  }))))))));
};
export { SvgAvatar as ReactComponent };
export default __webpack_public_path__ + "avatar.svg";